import ConsoleLogger from './console.logger';

export default {
  debug: ConsoleLogger.debug,
  error: ConsoleLogger.error,
  info: ConsoleLogger.info,
  warning: ConsoleLogger.warning
};
